import { types } from 'mobx-state-tree';

export const WebShopItem = types.model('WebShopItem', {
    id: types.maybeNull(types.string),
    name: types.maybeNull(types.string),
    clientId: types.maybeNull(types.string),
});
